import React from 'react'
import { string, shape, array, bool } from 'prop-types'
import { productPrice } from '@helpers/product'
import { stripHtml } from '@helpers/string-helper'
import { productUrl } from '@helpers/route'
import { getCanonicalUrl } from '@helpers/canonical'

export default function ProductJsonLd({ product }) {
  const data = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "${product.title}",
    "image": "${[].concat(product.primary_image).concat(product.alternate_images)}",
    "description": "${product.description ? stripHtml(product.description) : ''}",
    "sku": "${product.sku}",
    "brand": {
      "@type": "Thing",
      "name": "${product.brand ? product.brand : 'Rooms To Go'}"
    },
    "offers": {
      "@type": "Offer",
      "url": "${getCanonicalUrl(productUrl(product.route))}",
      "priceCurrency": "USD",
      "price": "${productPrice(product)}",
      "itemCondition": "http://schema.org/NewCondition",
      "seller": {
        "@type": "Organization",
        "name": "Rooms To Go"
      }
    }
  }`

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: data }} />
}

ProductJsonLd.propTypes = {
  product: shape({
    title: string,
    primary_image: string,
    alternate_images: array,
    description: string,
    sku: string,
    brand: string,
  }),
}
